"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebsiteProperty = exports.websitePropertyDefinition = void 0;
exports.websitePropertyDefinition = {
    view: {
        label: 'Other website',
        style: 'url',
        hint: 'Please enter a valid URL!',
    },
    constraints: [
        {
            name: 'pattern',
            argument: '^https?:\\/\\/(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#]\\S*)?$',
        },
    ],
    type: 'text',
    multiple: false,
    name: 'website',
};
const isWebsiteProperty = (prop) => {
    return prop.name === exports.websitePropertyDefinition.name;
};
exports.isWebsiteProperty = isWebsiteProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2Vic2l0ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3dlYnNpdGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx5QkFBeUIsR0FBRztJQUN2QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsZUFBZTtRQUN0QixLQUFLLEVBQUUsS0FBSztRQUNaLElBQUksRUFBRSwyQkFBMkI7S0FDbEM7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLGtlQUFrZTtTQUM3ZTtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxTQUFTO0NBQ2dCLENBQUE7QUFJMUIsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLElBQWtCLEVBQTJCLEVBQUU7SUFDL0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGlDQUF5QixDQUFDLElBQUksQ0FBQTtBQUNyRCxDQUFDLENBQUE7QUFGWSxRQUFBLGlCQUFpQixxQkFFN0IifQ==